import { t } from '$lib/i18n';
import { createUiI18n, type UiI18n } from '$components/ui/i18n.js';

export function getUiComponentsI18n(): UiI18n {
	return createUiI18n({
		selectPlaceholder: t('undefined'),
		showPassword: t('showPassword'),
		hidePassword: t('hidePassword'),
		previousYear: t('previousYear'),
		nextYear: t('nextYear'),
		noItems: t('noItems'),
		loading: t('loading'),
		noResults: t('noResults'),
		createNew: t('createNew'),
		noItemsFound: t('noItemsFound'),
		clearFilters: t('clearFilters'),
		remove: t('remove')
	});
}
